import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
};

const profileSlice = createSlice({
  name: "profile-slice",
  initialState,
  reducers: {
    openDeleteAcountModal: (state, action) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export default profileSlice.reducer;
export const { openDeleteAcountModal } = profileSlice.actions;
